import { createFileRoute } from '@tanstack/react-router';

import {
  attributesQueryOptions,
  productTypesQueryOptions,
  skuRuleQueryOptions,
  skuRulesQueryOptions,
  SkuRulesPage,
} from '@/features/dictionary';

export const Route = createFileRoute('/_authed/_active/org/catalog-setup/sku-rules/$ruleId')({
  loader: async ({ context, params }) => {
    const [rule] = await Promise.all([
      context.queryClient.query({ ...skuRuleQueryOptions(params.ruleId), staleTime: 'static' }),
      context.queryClient
        .query({ ...attributesQueryOptions(), staleTime: 'static' })
        .catch(() => undefined),
      context.queryClient
        .query({ ...productTypesQueryOptions(), staleTime: 'static' })
        .catch(() => undefined),
      context.queryClient
        .query({ ...skuRulesQueryOptions(), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    return { crumb: rule.name };
  },
  component: SkuRuleDetail,
});

function SkuRuleDetail() {
  const { ruleId } = Route.useParams();
  return <SkuRulesPage view="edit" ruleId={ruleId} />;
}
